const ssyhTextObj = {
    yhbg:{
        smallText:'优惠报告能够根据企业的不同性质、项目行为和行业特点，对国内所有的税收优惠政策进行深入分析，并即时生成个性化的税收优惠报告。通过智能匹配和分析，帮助企业迅速了解并利用适用的税收优惠政策，最大化税务效益。 ',
        titleLeftText:'优惠报告能够',
        titleBlue:'根据企业的不同性质、项目行为和行业特点，对国内所有的税收优惠政策进行深入分析，并即时生成个性化的税收优惠报告。通过智能匹配和分析，帮助企业迅速了解并利用适用的税收优惠政策，最大化税务效益。',
        detailList:[
            {
                title:'一、主要作用：',
                desc:[
                    {
                        text:'政策匹配：根据企业的具体特征（如企业性质、行业、项目等），自动匹配适用的税收优惠政策。',
                    },
                    {
                        text:'即时报告：即刻生成详细的税收优惠报告，列出所有可享受的税收优惠条款及其条件。',
                    },
                    {
                        text:'节省成本：通过充分利用税收优惠政策，帮助企业降低税负，节约运营成本。',
                    },
                    {
                        text:'合规指导：提供详细的政策解读和操作指南，确保企业在享受优惠的同时符合相关法规要求。',
                    },
                    {
                        text:'决策支持：为企业的财务和税务规划提供数据支持，辅助管理层做出更明智的决策。',
                    }
                ],
            },
            {
                title:'二、对企业客户的价值：',
                desc:[
                    {
                        text:'降低成本：通过识别和应用税收优惠政策，减少企业的税务负担。',
                    },
                    {
                        text:'提高效率：自动化生成报告，省去人工查找和分析的时间，提高工作效率。',
                    },
                    {
                        text:'增强合规性：确保企业在享受税收优惠时遵守相关法律法规，避免潜在风险。',
                    },
                    {
                        text:'优化策略：基于详细的税收优惠信息，优化企业的财务和税务策略，提升整体竞争力。',
                    },
                    {
                        text:'个性化服务：针对不同企业的特定需求，提供定制化的税收优惠报告，确保信息的相关性和实用性。',
                    }
                ],
            },
            {
                title:'三、主要卖点：',
                desc:[
                    {
                        text:'精准匹配：智能分析企业特征，精准匹配适用的税收优惠政策。',
                    },
                    {
                        text:'即时生成：快速生成详细的税收优惠报告，提供实时信息。',
                    },
                    {
                        text:'全面覆盖：包含国内所有现行的税收优惠政策，确保信息全面。',
                    },
                    {
                        text:'易于理解：报告内容清晰易懂，附带详细的操作指南。',
                    },
                    {
                        text:'持续更新：跟踪最新的税收政策变化，确保报告内容的时效性和准确性。',
                    },
                    {
                        text:'专业支持：提供专业的财税专家团队支持，解答疑问并提供进一步的建议。',
                    },
                    {
                        text:'通过这一功能，企业可以轻松获取并利用适合自身的税收优惠政策，从而在激烈的市场竞争中获得更大的优势。',
                    }
                ],
            }
        ]
    },
    xmbg:{
        smallText:'项目报告能够根据项目的具体特点，对国内所有的税收优惠项目进行分类和智能匹配，即时生成详细的税收优惠项目报告。通过这一功能，企业可以迅速了解并利用适用于其项目的税收优惠政策，最大化税务效益。',
        titleLeftText:'项目报告能够',
        titleBlue:'根据项目的具体特点，对国内所有的税收优惠项目进行分类和智能匹配，即时生成详细的税收优惠项目报告。通过这一功能，企业可以迅速了解并利用适用于其项目的税收优惠政策，最大化税务效益。',
        detailList:[
            {
                title:'一、主要作用：',
                desc:[
                    {
                        text:'政策分类：将所有税收优惠政策按项目性质、行业、地区等进行分类。',
                    },
                    {
                        text:'智能匹配：根据项目的具体特征（如项目类型、投资规模、所在地区等），自动匹配适用的税收优惠政策。',
                    },
                    {
                        text:'即时报告：即刻生成详细的税收优惠报告，列出所有可享受的税收优惠条款及其条件。',
                    },
                    {
                        text:'节省成本：通过充分利用税收优惠政策，帮助企业降低税负，节约运营成本。',
                    },
                    {
                        text:'合规指导：提供详细的政策解读和操作指南，确保企业在享受优惠的同时符合相关法规要求。',
                    },
                    {
                        text:'决策支持：为企业的财务和税务规划提供数据支持，辅助管理层做出更明智的决策。',
                    }
                ],
            },
            {
                title:'二、对企业客户的价值：',
                desc:[
                    {
                        text:'降低成本：通过识别和应用税收优惠政策，减少企业的税务负担。',
                    },
                    {
                        text:'提高效率：自动化生成报告，省去人工查找和分析的时间，提高工作效率。',
                    },
                    {
                        text:'增强合规性：确保企业在享受税收优惠时遵守相关法律法规，避免潜在风险。',
                    },
                    {
                        text:'优化策略：基于详细的税收优惠信息，优化企业的财务和税务策略，提升整体竞争力。',
                    },
                    {
                        text:'个性化服务：针对不同企业的特定需求，提供定制化的税收优惠报告，确保信息的相关性和实用性。',
                    }
                ],
            },
            {
                title:'三、主要卖点：',
                desc:[
                    {
                        text:'精准匹配：智能分析企业特征，精准匹配适用的税收优惠政策。',
                    },
                    {
                        text:'即时生成：快速生成详细的税收优惠报告，提供实时信息。',
                    },
                    {
                        text:'全面覆盖：包含国内所有现行的税收优惠政策，确保信息全面。',
                    },
                    {
                        text:'易于理解：报告内容清晰易懂，附带详细的操作指南。',
                    },
                    {
                        text:'持续更新：跟踪最新的税收政策变化，确保报告内容的时效性和准确性。',
                    },
                    {
                        text:'专业支持：提供专业的财税专家团队支持，解答疑问并提供进一步的建议。',
                    },
                    {
                        text:'通过这一功能，企业可以轻松获取并利用适合自身的税收优惠政策，从而在激烈的市场竞争中获得更大的优势。',
                    }
                ],
            }
        ]
    }
}

export {
    ssyhTextObj
}